import React from "react"

import { Container } from "react-bootstrap"
import SEO from "../seo"

const PayFailed = () => {
  return (
    <Container className="mt-5 pt-5 mb-5 pb-5 text-center">
      <SEO title="Failed | WDN" />
      <h1>Failed !</h1>
      <h3>Your transaction was incomplete.</h3>
      <p>
        This may be because of insufficient amount or cancellation. Please try
        again.
      </p>
    </Container>
  )
}

export default PayFailed
